const steps = [
  { number: '01', icon: 'ri-phone-line', title: 'Contact & Évaluation', description: 'Contactez-nous par téléphone ou email. Nous évaluons vos besoins et organisons une visite gratuite sur site si nécessaire.' },
  { number: '02', icon: 'ri-file-text-line', title: 'Devis Personnalisé', description: 'Nous vous remettons un devis détaillé et transparent sous 24h, adapté à votre surface, vos besoins et votre fréquence souhaitée.' },
  { number: '03', icon: 'ri-calendar-check-line', title: 'Planification', description: 'Nous convenons ensemble des horaires d\'intervention qui vous conviennent le mieux, sans perturber votre quotidien ou votre activité.' },
  { number: '04', icon: 'ri-sparkling-2-line', title: 'Intervention & Contrôle', description: 'Notre équipe intervient avec professionnalisme. Un contrôle qualité est effectué à chaque prestation pour garantir votre satisfaction.' },
];

export default function NettoyageProcess() {
  return (
    <section className="py-24 bg-gray-900">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-base font-semibold text-orange-400 mb-2">Notre Méthode</h2>
          <p className="text-4xl font-bold text-white mb-4">Comment ça fonctionne ?</p>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto">
            Un processus simple et efficace pour vous garantir un service de qualité à chaque intervention.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-10 left-full w-full h-0.5 bg-orange-500/20 z-0" style={{ width: 'calc(100% - 2.5rem)', left: '2.5rem' }}></div>
              )}
              <div className="relative z-10 text-center">
                <div className="relative inline-flex">
                  <div className="w-20 h-20 flex items-center justify-center bg-orange-500 rounded-2xl mx-auto mb-5">
                    <i className={`${step.icon} text-3xl text-white`}></i>
                  </div>
                  <span className="absolute -top-2 -right-2 w-7 h-7 flex items-center justify-center bg-gray-700 text-orange-400 text-xs font-bold rounded-full border border-orange-500/40">
                    {step.number}
                  </span>
                </div>
                <h3 className="text-lg font-bold text-white mb-3">{step.title}</h3>
                <p className="text-sm text-gray-400 leading-relaxed">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
